import { faChevronDown, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useMembersContext } from '@/contexts/membersContext';
import AuthRepository from '@/repositories/members/AuthRepository';
import Avatar from '@/ui/members/components/Avatar';
import Dropdown from '@/ui/members/components/Dropdown';

export const Header = () => {
  const authRepository = AuthRepository();
  const { memberData, getMemberFullName } = useMembersContext();
  const handleLogout = async () => {
    await authRepository.logout();
    window.location.href = `${process.env.VITE_APP_WEBSITE_URL}/download-and-schedule`;
  };

  return (
    <header className="w-full flex items-center justify-between px-6 h-20 shadow-sm sticky top-0 z-20 bg-inherit dark:bg-gray-700 light:bg-gray-700">
      <img
        src="/images/members/header-logo.svg"
        alt="Logo"
        className="h-6 w-auto hidden sm:block"
      />
      <div className="ml-auto">
        <Dropdown
          buttonText={
            <span className="flex items-center gap-2">
              <Avatar
                name={getMemberFullName(false, false)}
                size="medium"
                avatarUrl={memberData?.person.profile_image_url}
              />
              <span className="font-medium text-gray-900 dark:text-gray-100 truncate max-w-xs">
                {getMemberFullName(true, true)}
              </span>
              <FontAwesomeIcon icon={faChevronDown} className="text-gray-900 dark:text-gray-100" />
            </span>
          }
          customButtonClassName="bg-transparent shadow-none px-0 py-0 hover:bg-transparent focus:bg-transparent"
          showChevronIcon={false}>
          <button
            className="mx-2 my-1 px-4 py-1 cursor-pointer hover:bg-gray-600 rounded-md flex items-center"
            onClick={handleLogout}>
            <FontAwesomeIcon className="mr-2" icon={faSignOut} />
            Logout
          </button>
        </Dropdown>
      </div>
    </header>
  );
};
